export default "__VITE_ASSET__B437uc_4__"